import type { NextRouter } from 'next/router';

function getMarkdownPath(router: NextRouter) {
	const asPath = router?.asPath?.split('?')[0]?.split('#')[0] || '';
	const basePath = router?.basePath || '';

	if (!asPath) return '';
	if (asPath.endsWith('.md')) return asPath;

	const path = `${asPath}.md`;
	if (!basePath) return path;
	if (path.startsWith(`${basePath}/`)) return path;

	return `${basePath}${path}`;
}

export { getMarkdownPath };
